import Vapi from '@borisp/vuex-rest-api'
import { getOptimisticDeleteAssignments, payloadToState } from '../../utils/helpers'
import { VUE_APP_BASE_API_URL }  from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    broadcasts: [],
    broadcastsMetadata: {},
    broadcastOverview: {}
  }
})
  .get({
    queryParams: true,
    action: 'getBroadcasts',
    property: 'broadcasts',
    path: '/broadcasts/',
    onSuccess: payloadToState('broadcasts')
  })
  .get({
    action: 'getBroadcast',
    property: 'broadcast',
    queryParams: true,
    path: ({ id }) => `/broadcasts/${id}`,
    onSuccess: payloadToState('broadcast')
  })
  .get({
    action: 'getBroadcastOverview',
    property: 'broadcastOverview',
    path: '/broadcasts/overview',
    onSuccess: payloadToState('broadcastOverview')
  })
  .put({
    action: 'updateBroadcast',
    property: 'broadcast',
    path: ({ id }) => `/broadcasts/${id}`,
    onSuccess: payloadToState('broadcast')
  })
  .delete({
    action: 'deleteBroadcast',
    property: 'broadcast',
    path: ({ id }) => `/broadcasts/${id}/assignments`,
    beforeRequest: getOptimisticDeleteAssignments('broadcasts'), // fingers crossed!
    onSuccess: payloadToState('broadcast')
  })
  .getStore()
